(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["artists-intro"]) return;
  try {
    
  $(document).ready(function() {
    $('.artist-accordion .accordion-container').on("click", function() {
       $(this).toggleClass('active');
       $(this).children('.description').slideToggle( "slow" );
       if ($(this).siblings('.active').length != 0) {
        $(this).siblings('.active').children('.description').slideToggle( "slow" );
        $(this).siblings('.active').removeClass('active');
       }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filters"]) return;
  try {
    
  $(document).ready(function() {
    $('.filter-container .title').on("click", function() {
       $(this).next().slideToggle( "slow" );
       $(this).toggleClass('active');
    });
  });

  $('.filter_checkbox').off().change( function(){
    var newURL = $(this).nextAll('a').attr('href');
    window.location.href = newURL;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
  var featuredCollectionSwiper = new Swiper('.featured-collection-swiper', {
      navigation: {
        nextEl: '.fc-arrow.swiper-button-next',
        prevEl: '.fc-arrow.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination.fc-pagination',
        clickable: true,
      },
      loop: true,
      slidesPerView: 2,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 60,
          centeredSlides: true,
        },
      },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["past-packs"]) return;
  try {
    
  new Swiper('.recommendations-swiper', {
    navigation: {
      nextEl: '.fc-arrow.swiper-button-next',
      prevEl: '.fc-arrow.swiper-button-prev',
    },
    /*slidesPerView: 4,
    loop: false,
    centerInsufficientSlides: true,
    spaceBetween: 24,*/
    slidesPerView: 1.7,
    spaceBetween: 24,
    centerInsufficientSlides: true,
    slidesOffsetBefore: 23,
    slidesOffsetAfter: 23,
    breakpoints: {
      750: {
        touchRatio: 0,
        slidesPerView: 4,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

})();
